import { motion } from "framer-motion";

const BEFORE_AFTER = [
  { before: "You re-explain the product and design rules at the start of every chat.", after: "Your connected agents can read the current product direction and design rules before they build." },
  { before: "The product changes, but the strategy and designs stay in old documents.", after: "Pabs uses new evidence to propose strategy updates and carries agreed design direction into the next brief." },
  { before: "You discover the wrong feature or an inconsistent experience after the work is finished.", after: "With Design Authority enabled, Pabs checks returned work against the brief and design rules, then proposes focused corrections." },
];

const Check = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="shrink-0 mt-0.5">
    <circle cx="9" cy="9" r="9" fill="#171923" />
    <path d="M5 9l3 3 5-5" stroke="#f7fafc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function WhatChanged() {
  return (
    <section id="platform-shift" className="py-32 bg-gradient-to-b from-brand-900 to-brand-800 relative overflow-hidden border-t border-brand-50/10">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:80px_80px]"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-900/50 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">

          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-7xl font-medium mb-8 leading-tight text-white">
              What changes when strategy &amp; design live in the build.
            </h2>
            <p className="text-xl text-brand-400 leading-relaxed font-light max-w-3xl mx-auto">
              Strategy sat in a document. Design decisions stayed in files and chats.
              As you built, both drifted.{' '}
              <strong className="font-medium text-brand-50">Now your agents can ship changes every day. They need to know what to build and how it should work.</strong>{' '}
              Pabs carries the Brief, design rules and agreed decisions into their work,
              then uses reviews and learnings to guide the next change.
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="flex flex-col md:flex-row items-stretch"
          >
            {/* Before — left card */}
            <div className="flex-1 rounded-[2rem] border border-brand-50/10 bg-brand-50/[0.03] backdrop-blur-md overflow-hidden flex flex-col">
              <div className="px-8 py-5 border-b border-brand-50/10">
                <span className="text-[11px] font-bold text-brand-500 uppercase tracking-widest">Before</span>
              </div>
              {BEFORE_AFTER.map((row, i) => (
                <div key={i} className="px-8 md:pr-20 py-6 border-b border-brand-50/10 last:border-0 flex-1 flex items-center">
                  <p className="text-brand-400 text-sm leading-relaxed line-through decoration-brand-700">
                    {row.before}
                  </p>
                </div>
              ))}
            </div>

            {/* With Pabs — white card, negative left margin to overlap */}
            <div className="md:-ml-12 mt-4 md:mt-0 w-full md:w-[55%] shrink-0 rounded-[2rem] bg-brand-50 shadow-2xl overflow-hidden flex flex-col z-10 relative">
              <div className="px-8 py-5 border-b border-brand-200">
                <span className="text-[11px] font-bold text-brand-900 uppercase tracking-widest">With Pabs</span>
              </div>
              {BEFORE_AFTER.map((row, i) => (
                <div key={i} className="px-8 py-6 border-b border-brand-100 last:border-0 flex items-start gap-3 flex-1">
                  <Check />
                  <p className="text-brand-900 text-sm font-medium leading-relaxed">
                    {row.after}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
